
import Logo from '../Logo'

export default {
  components: {
    Logo,
  },
}
